import React from "react";
import { useNavigate } from "react-router-dom";

import { ActionButton, Container, Icon, Image, Text } from "@jds/core";
import banner from "../assets/png/404-02 1.png";
import { useSelector } from "react-redux";

const NotFound = () => {
  const navigate = useNavigate();
  const loginDetails = useSelector((state) => state.auth.loginDetails);
  const isJitoUser = loginDetails?.userType === "JITO";
  console.log(isJitoUser)
  return (
    <Container
      fullWidth
      verticalAlign="center"
      style={{ height: "100vh" }}
      horizontalAlign="center"
    >
      <Container direction="column" horizontalAlign="center" gap={1}>
        <Container
          style={{
            height: "180px",
            width: "180px",
          }}
        >
          <Image src={banner} aspectRatio="1:1" />
        </Container>
        <Text appearance="heading-xs">Page Not Found</Text>
        <Container
          fullWidth
          horizontalAlign="center"
          style={{ margin: "16px 0 20px" }}
          direction="column"
        >
          <Text appearance="body-m" color="primary_grey_80">
            The page can’t be reached, but if
          </Text>
          <Text appearance="body-m" color="primary_grey_80">
            you double-check it, we’re happy to try again.
          </Text>
        </Container>
        <ActionButton
          size="large"
          icon={"IcArrowBack"}
          label={isJitoUser ? "Back" : "Back to Homepage"}
          onClick={() => isJitoUser ? navigate("/home") : navigate(-1)}
        ></ActionButton>
      </Container>
    </Container>
  );
};

export default NotFound;
